import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { LayoutDashboard, Users, Car, FileText, BarChart3, Settings, LogOut, FolderOpen, Building2, UserCheck, Wallet, Receipt, ScrollText, Megaphone } from "lucide-react";

const GARAGE_NAV = [
  { to: "/", icon: LayoutDashboard, label: "Panel" },
  { to: "/tenants", icon: Users, label: "Inquilinos" },
  { to: "/parking-spots", icon: Car, label: "Plazas" },
  { to: "/invoices", icon: FileText, label: "Facturas" },
  { to: "/contracts", icon: FolderOpen, label: "Contratos" },
  { to: "/vat-reports", icon: BarChart3, label: "Informes IVA" },
];

const COMMUNITY_NAV = [
  { to: "/community", icon: Building2, label: "Panel" },
  { to: "/community/owners", icon: UserCheck, label: "Propietarios" },
  { to: "/community/fees", icon: Wallet, label: "Cuotas" },
  { to: "/community/expenses", icon: Receipt, label: "Gastos" },
  { to: "/community/minutes", icon: ScrollText, label: "Actas" },
  { to: "/community/notices", icon: Megaphone, label: "Circulares" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen bg-[#F9FAFB]">
      <aside className="w-60 bg-white border-r border-gray-200 flex flex-col fixed h-full z-20" data-testid="sidebar">
        <div className="p-6 border-b border-gray-200">
          <h1 className="text-xl font-black tracking-tight text-[#002FA7]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
            GarajeFact
          </h1>
          <p className="text-xs text-gray-400 mt-1 tracking-wide uppercase font-bold">Gestion de Facturas</p>
        </div>
        <nav className="flex-1 py-4 px-3 space-y-1 overflow-y-auto" data-testid="sidebar-nav">
          <p className="px-4 py-1 text-[10px] tracking-[0.2em] uppercase font-bold text-gray-400">Garaje</p>
          {GARAGE_NAV.map(({ to, icon: Icon, label }) => (
            <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => `sidebar-link ${isActive ? "active" : "text-gray-600"}`} data-testid={`nav-${label.toLowerCase().replace(/\s/g, '-')}`}>
              <Icon className="w-4 h-4" strokeWidth={2} />{label}
            </NavLink>
          ))}
          <div className="my-3 border-t border-gray-200" />
          <p className="px-4 py-1 text-[10px] tracking-[0.2em] uppercase font-bold text-gray-400">Comunidad</p>
          {COMMUNITY_NAV.map(({ to, icon: Icon, label }) => (
            <NavLink key={to} to={to} end={to === "/community"} className={({ isActive }) => `sidebar-link ${isActive ? "active" : "text-gray-600"}`} data-testid={`nav-com-${label.toLowerCase().replace(/\s/g, '-')}`}>
              <Icon className="w-4 h-4" strokeWidth={2} />{label}
            </NavLink>
          ))}
          <div className="my-3 border-t border-gray-200" />
          <NavLink to="/settings" end className={({ isActive }) => `sidebar-link ${isActive ? "active" : "text-gray-600"}`} data-testid="nav-configuracion">
            <Settings className="w-4 h-4" strokeWidth={2} />Configuracion
          </NavLink>
        </nav>
        <div className="p-3 border-t border-gray-200">
          <div className="px-4 py-2 text-xs text-gray-400 truncate">{user?.email}</div>
          <button
            onClick={handleLogout}
            className="sidebar-link text-gray-600 hover:text-red-600 w-full"
            data-testid="logout-button"
          >
            <LogOut className="w-4 h-4" strokeWidth={2} />
            Cerrar sesion
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-60 p-8">
        <Outlet />
      </main>
    </div>
  );
}
